import React from 'react';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import PropTypes from 'prop-types';
/* const renderTextField = ({
    input,
    label,
    meta: { touched, error },
    ...custom
  }) => (
    <TextareaAutosize
      aria-label="minimum height"
      errorText={touched && error}
      {...input}
      {...custom}
    />
  ) */
const CustomTextAreaField = props => {
  const {
    input,
    label,
    symbol,
    meta: { touched, error },
    ...other
  } = props;

  return (
    <div>
      <label>{label}</label>
      <div style={{ width: '70%' }}>
        <TextareaAutosize
          aria-label="minimum height"
          errorText={touched && error}
          helperText={touched && error}
          label={symbol}
          style={{ textAlign: 'left', borderRadius: 28 }}
          {...input}
          {...other}
        />
        <br />
      </div>
    </div>
  );
};

CustomTextAreaField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  type: PropTypes.string,
  currencySymbol: PropTypes.string,
  symbol: PropTypes.string,
};
export default CustomTextAreaField;
